import { useState, useCallback } from 'react';
import { message } from 'antd';
import { useFiles } from '@/contexts/FileContext';
import { FILE_CONFIG } from '@/constants/file.constants';

export const useFileUpload = (tournamentId: number) => {
  const [uploading, setUploading] = useState(false);
  const { uploadFile } = useFiles();

  const validateFile = (file: File): boolean => {
    if (file.size > FILE_CONFIG.UPLOAD.MAX_SIZE) {
      message.error(FILE_CONFIG.UPLOAD.ERROR_MESSAGES.SIZE);
      return false;
    }

    if (!FILE_CONFIG.UPLOAD.MIME_TYPES.includes(file.type as any)) {
      message.error(FILE_CONFIG.UPLOAD.ERROR_MESSAGES.TYPE);
      return false;
    }

    return true;
  };

  const handleUpload = useCallback(
    async (file: File) => {
      if (!validateFile(file)) {
        return;
      }

      try {
        setUploading(true);
        await uploadFile(tournamentId, file);
        message.success(`Файл ${file.name} успешно загружен`);
      } catch (error) {
        message.error(`Ошибка при загрузке файла ${file.name}`);
      } finally {
        setUploading(false);
      }
    },
    [tournamentId, uploadFile]
  );

  return {
    uploading,
    handleUpload
  };
};